<script setup>
import {
  computed,
  toRefs,
} from 'vue';
import { useI18n } from 'vue-i18n';
import useDataStore from '@/stores/data';

const { t } = useI18n();
const {
  getKakaoProfile,
} = useDataStore();

// kakaoProfile
const kakaoProfileData = getKakaoProfile();

const props = defineProps({
  kakaoProfile: {
    type: String,
    default: '',
  },
});

const {
  kakaoProfile,
} = toRefs(props);

const profile = computed(() => {
  const { value: id } = kakaoProfile;

  if (!id) {
    return '';
  }

  let profileString = '';
  (kakaoProfileData?.list || []).some(({ label, value }) => {
    if (value === id) {
      profileString = label;
      return true;
    }

    return false;
  });

  return profileString;
});

</script>
<template>
  <span class="advertisement">
    <em>({{ t('kakaoBasic.preview.header') }})</em>
    {{ profile }}
  </span>
</template>
